import { hasValidConsent } from '@achieve/cx-event-horizon/browser'
import { cookieStringHasConsentBanner } from 'constants/consentBannerCookies'
import { isEhConsentTealiumEnabled } from './ehConsentTealiumEnabled'

/**
 * When the EH consent pilot is on, marketing/tracking vendors may run only after eh_consent_v1 is valid
 * or a legacy banner-dismiss cookie is present (same gate as EventHorizonTealium bootstrap, ADR-011).
 * When the pilot is off, behavior is unchanged (always allowed).
 */
export function isEhTrackingAllowed() {
  if (!isEhConsentTealiumEnabled()) return true
  if (typeof window === 'undefined') return false
  if (hasValidConsent()) return true
  return cookieStringHasConsentBanner(document.cookie)
}
